// extracted by mini-css-extract-plugin
export default {"wrapperFilters":"portfolioTrendsSection_wrapperFilters__8G22M","wrapFilterField":"portfolioTrendsSection_wrapFilterField__dvlUp"};